// Generated from packages/workflow-builder/iconConverter.js
import { SvgIconProps, createSvgIcon } from '@automata/mui-theme';
import { BrokenImageOutlined as BrokenImageOutlinedIcon } from '@automata/mui-theme/icons';
import { logger } from '@automata/utils';
import { memo } from 'react';

import { DeepWellPlateIcon } from './DeepWellPlateIcon';
import { MicroplateIcon } from './MicroplateIcon';
import { PlaceholderIcon } from './PlaceholderIcon';
import { ReservoirIcon } from './ReservoirIcon';
import { TiprackIcon } from './TiprackIcon';
import { TuberackIcon } from './TuberackIcon';

export {
  DeepWellPlateIcon,
  MicroplateIcon,
  PlaceholderIcon,
  ReservoirIcon,
  TiprackIcon,
  TuberackIcon,
};

export const getIcon = (iconName: string): ReturnType<typeof createSvgIcon> => {
  switch (iconName) {
    case 'deepwellplate':
      return DeepWellPlateIcon;
    case 'microplate':
      return MicroplateIcon;
    case 'placeholder':
      return PlaceholderIcon;
    case 'reservoir':
      return ReservoirIcon;
    case 'tiprack':
      return TiprackIcon;
    case 'tuberack':
      return TuberackIcon;
    default:
      logger.log(`no icon for iconName ${iconName}`);
      return BrokenImageOutlinedIcon;
  }
};

export const Icon = memo(function Memoized({
  iconType,
  ...otherProps
}: SvgIconProps & { iconType: string }) {
  const Icon = getIcon(iconType.replace(/[-_]/g, ''));
  return <Icon style={{ fill: 'currentColor' }} {...otherProps} />;
});
